// extracted by mini-css-extract-plugin
export var cookieButtons = "CookieConsent-module--cookieButtons--1d28d";
export var cookieContainer = "CookieConsent-module--cookieContainer--d8728";
export var cookieContent = "CookieConsent-module--cookieContent--79292";
export var cookieText = "CookieConsent-module--cookieText--05437";